import { render } from "./CreateBulkForm.vue?vue&type=template&id=3dbe6828&ts=true"
import script from "./CreateBulkForm.vue?vue&type=script&lang=ts"
export * from "./CreateBulkForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__